var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.75H12V7.25H4V8.75ZM13.25 10V13H14.75V10H13.25ZM12 14.25H4V15.75H12V14.25ZM2.75 13V10H1.25V13H2.75ZM4 14.25C3.30964 14.25 2.75 13.6904 2.75 13H1.25C1.25 14.5188 2.48122 15.75 4 15.75V14.25ZM13.25 13C13.25 13.6904 12.6904 14.25 12 14.25V15.75C13.5188 15.75 14.75 14.5188 14.75 13H13.25ZM12 8.75C12.6904 8.75 13.25 9.30964 13.25 10H14.75C14.75 8.48122 13.5188 7.25 12 7.25V8.75ZM4 7.25C2.48122 7.25 1.25 8.48122 1.25 10H2.75C2.75 9.30964 3.30964 8.75 4 8.75V7.25Z",
    fill: "#747D90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6V5C12 2.79086 10.2091 1 8 1V1C5.79086 1 4 2.79086 4 5V6",
    stroke: "#747D90",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.80c88eec60bbfb8bcc8945c3298daa79.svg";
export { ForwardRef as ReactComponent };